<template>
    <ul>
        <li v-for="category in content.mobile" class="mainItem">
            <a href="#" v-on:click="categoryClick($event, category)" class="has-sub">{{category.name}}</a>
            <div v-if="isDisplayFor('mobile')" class="level02">
                <ul>
                    <li v-for="subcat in category.items">
                        <a href="#" v-on:click="categoryClick($event, subcat)"
                           :class="{'has-sub':subcat['sub-sub-items'].length}">{{subcat['sub-item'].name}}</a>
                        <div class="level03">
                            <ul>
                                <li v-for="subSubcat in subcat['sub-sub-items']">
                                    <a :href="subSubcat.url"
                                       @click="subcatClick($event, subSubcat)">{{subSubcat.name}}</a>
                                </li>
                            </ul>
                        </div>
                    </li>
                </ul>
            </div>

            <div v-if="isDisplayFor('desktop')" class="level02 newColumns">
                <div class="bottomBar menuHeaderBar">
                    <button>
                        <a :href="category.url" class="menuHeaderText ">{{category.name}} HOME</a>
                        <svg-icon icon-name="icon-chevron-down"></svg-icon>
                    </button>
                    <div class="level01">
                        <ul>
                            <li v-for="subCat in category.items">
                                <a v-if="subCat['sub-sub-items'].length" class="has-sub" href="#"
                                   v-on:click="categoryClick($event, subCat)">
                                    <strong v-if="subCat['sub-item']['is-bold']">{{subCat['sub-item'].name}}</strong>
                                    <span v-else>{{subCat['sub-item'].name}}</span>
                                </a>
                                <a v-if="!subCat['sub-sub-items'].length" :href="subCat['sub-item'].url"
                                   v-on:click="categoryClick($event, subCat)">
                                    <strong v-if="subCat['sub-item']['is-bold']">{{subCat['sub-item'].name}}</strong>
                                    <span v-else>{{subCat['sub-item'].name}}</span>
                                </a>
                                <div v-if="subCat['sub-sub-items'].length" class="level02 newColumns">
                                    <div class="bottomBar menuHeaderBar">
                                        <button>
                                            <a :href="subCat['sub-item'].url" class="menuHeaderText">
                                                <strong v-if="subCat['sub-item']['is-bold']">{{subCat['sub-item'].name}}</strong>
                                                <span v-else>{{subCat['sub-item'].name}}</span>
                                            </a>
                                            <svg-icon icon-name="icon-chevron-down"></svg-icon>
                                        </button>
                                        <div class="level01">
                                            <ul>
                                                <li v-for="subSubCat in subCat['sub-sub-items']">
                                                    <a :href="subSubCat.url" v-on:click="subcatClick($event, subSubCat)"
                                                       class="menuLastLevel">
                                                        <strong v-if="subSubCat['is-bold']">{{subSubCat.name}}</strong>
                                                        <span v-else>{{subSubCat.name}}</span>
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </li>
    </ul>
</template>

<script>
    import SvgIcon from './SvgIcon.vue';
    import common from './../module/common'

    let subcatClick = (event, subcat) => {
        event.preventDefault();
        window.location.href = subcat.url;
    };

    let setColumnMaxHeight = () => {
        let mainColumnHeaderHeight = $('.js-mainNavBarToggle').height();
        let mainColumnHeight = $('.foreground').height();
        let secondColumn = $('header .bottomBar .containerFluid .mainNavigation .mainNavBar .foreground nav .level01 .level02 .level01');
        let thirdColumn = $('header .bottomBar .containerFluid .mainNavigation .mainNavBar .foreground nav .level01 .level02 .level01 .level02 .level01');
        let columnLevel02 = $('header .bottomBar .containerFluid .mainNavigation .mainNavBar .foreground nav .level02');

        columnLevel02.css(`height: ${mainColumnHeaderHeight + mainColumnHeight} !important;`);
        secondColumn.height(mainColumnHeight);
        thirdColumn.height(mainColumnHeight);
    };

    let concatMenu = (component) => {
        let obj = {
            mobile: []
        };

        obj.mobile = [].concat(component.$root.menuContent.mobile, component.navTopJSON.mobile);

        return obj;
    };

    export default {
        props: {
            device: null,
            menuType: {
                default: 'mainNav'
            }
        },
        data() {
            return {
                navTopJSON: {
                    "mobile": [
                        {
                            "name": "ABOUT US",
                            "items": [
                                {
                                    "sub-item": {
                                        "id": 1997,
                                        "name": "ECO Friendly",
                                        "url": "/eco-friendly",
                                        "id-bold": 0
                                    },
                                    "sub-sub-items": []
                                },
                                {
                                    "sub-item": {
                                        "id": 1996,
                                        "name": "History",
                                        "url": "/history-page",
                                        "id-bold": 0
                                    },
                                    "sub-sub-items": []
                                },
                                {
                                    "sub-item": {
                                        "id": 1994,
                                        "name": "#MYCHALLENGE",
                                        "url": "/mychallenge",
                                        "id-bold": 0
                                    },
                                    "sub-sub-items": []
                                },
                                {
                                    "sub-item": {
                                        "id": 1995,
                                        "name": "Athletes",
                                        "url": "/athletes",
                                        "id-bold": 0
                                    },
                                    "sub-sub-items": []
                                },
                                {
                                    "sub-item": {
                                        "id": 199552,
                                        "name": "Leopard Pro Cycling",
                                        "url": "/pro-cycling",
                                        "id-bold": 0
                                    },
                                    "sub-sub-items": []
                                }

                            ]
                        },
                        {
                            "name": "PRODUCT INSIGHTS",
                            "items": [
                                {
                                    "sub-item": {
                                        "id": 2995,
                                        "name": "4 SEASONS",
                                        "url": "/4seasons",
                                        "id-bold": 0
                                    },
                                    "sub-sub-items": []
                                },
                                {
                                    "sub-item": {
                                        "id": 2996,
                                        "name": "Base Layers",
                                        "url": "/baselayers",
                                        "id-bold": 0
                                    },
                                    "sub-sub-items": []
                                },
                                {
                                    "sub-item": {
                                        "id": 2996,
                                        "name": "JONA Bib Shorts",
                                        "url": "/storypage",
                                        "id-bold": 0
                                    },
                                    "sub-sub-items": []
                                },
                                {
                                    "sub-item": {
                                        "id": 2997,
                                        "name": "Back Packs",
                                        "url": "/backpacks",
                                        "id-bold": 0
                                    },
                                    "sub-sub-items": []
                                },
                                {
                                    "sub-item": {
                                        "id": 2994,
                                        "name": "Development",
                                        "url": "/product-development",
                                        "id-bold": 0
                                    },
                                    "sub-sub-items": []
                                }
                            ]
                        },
                        {
                            "name": "EXPLORE",
                            "items": [
                                {
                                    "sub-item": {
                                        "id": 3994,
                                        "name": "News & Stories",
                                        "url": "/news",
                                        "id-bold": 0
                                    },
                                    "sub-sub-items": []
                                }
                            ]
                        },
                        {
                            "name": "CUSTOMER SERVICE",
                            "items": [
                                {
                                    "sub-item": {
                                        "id": 4994,
                                        "name": "Contact",
                                        "url": "/?action=landingpage/contact",
                                        "id-bold": 0
                                    },
                                    "sub-sub-items": []
                                },
                                {
                                    "sub-item": {
                                        "id": 4995,
                                        "name": "Impressum",
                                        "url": "/?action=landingpage/impressum-de",
                                        "id-bold": 0
                                    },
                                    "sub-sub-items": []
                                },
                                {
                                    "sub-item": {
                                        "id": 4996,
                                        "name": "Datenschutz",
                                        "url": "/?action=landingpage/datenschutz",
                                        "id-bold": 0
                                    },
                                    "sub-sub-items": []
                                },
                                {
                                    "sub-item": {
                                        "id": 4997,
                                        "name": "Garantie und Reklamationen",
                                        "url": "/?action=landingpage/garantie-und-reklamationen",
                                        "id-bold": 0
                                    },
                                    "sub-sub-items": []
                                },
                                {
                                    "sub-item": {
                                        "id": 4998,
                                        "name": "Widerrufsrecht und Rücksendung",
                                        "url": "/?action=landingpage/widerrufsrecht-und-rucksendung",
                                        "id-bold": 0
                                    },
                                    "sub-sub-items": []
                                },
                                {
                                    "sub-item": {
                                        "id": 4999,
                                        "name": "AGB",
                                        "url": "/?action=landingpage/agb",
                                        "id-bold": 0
                                    },
                                    "sub-sub-items": []
                                },
                            ]
                        }
                    ]
                },
                mqMedium: window.matchMedia("(min-width:740px) and (max-width: 980px)")
            }
        },
        computed: {
            content: function () {
                let menuContent = {};

                if (this.menuType === 'secondaryNav') {
                    menuContent = this.navTopJSON;
                } else {
                    if (this.device === 'desktop') {
                        if (this.mqMedium.matches && this.$root.menuContent.mobile) {
                            menuContent = concatMenu(this);
                        } else {
                            menuContent = this.$root.menuContent;
                        }

                    } else {
                        menuContent = this.$root.menuContent;
                    }
                }

                if (this.$root.menuContent.mobile) {
                    this.$nextTick(() => {
                        setColumnMaxHeight();

                        if (this.device === 'desktop') {
                            common.menuAngle();
                        }
                    })
                }
                return menuContent
            }
        },
        components: {
            'svg-icon': SvgIcon
        },
        methods: {
            isDisplayFor(device) {
                return this.device === device
            },
            subcatClick: function (event, subcat) {
                subcatClick(event, subcat);
            },
            categoryClick: (event, subcat) => {
                let element = event.currentTarget;
                let elementJQ = $(element);
                let li = element.parentElement;
                let ul = li.parentElement;
                let level = ul.parentElement;

                if (subcat['sub-sub-items'] && !subcat['sub-sub-items'].length) {
                    subcatClick(event, subcat["sub-item"]);
                    return;
                }

                if (level.className === 'level01') {
                    event.preventDefault();

                    changeDOM('level01', elementJQ);
                } else if (level.className === 'level02') {
                    event.preventDefault();

                    changeDOM('level02', elementJQ);
                }
            }
        },
        created() {
            let that = this;

            $(window).resize(function () {
                setTimeout(() => {
                    let mqMedium = window.matchMedia("(min-width:740px) and (max-width: 1023px)");
                    that.mqMedium = mqMedium;
                }, 500);
            });
        }
    }

    $(document).ready(() => {
        let defaulttextCont = $(".js-mobileNav .js-activeCategory");
        let defaultText = defaulttextCont.data("defaulttext");
        let body;
        defaulttextCont.text(defaultText);

        $('.mobileNav .mainNav').on('click', function () {
            $('.mobileNav .mainNav').addClass('hidden');
            $(this).removeClass('hidden');
        });

        $(".js-mainNavBarToggle").click(() => {
            $(".js-mainNavBar").toggleClass("is-active");
        });

        $(".js-mobileNavToggle").click(() => {
            body = $("body");
            if (body.hasClass("js-showMobileNav")) {
                body.removeClass("js-showMobileNav");
            }
            else {
                body.addClass("js-showMobileNav");
            }
        });


        $(".js-mobileNav .js-mobileNavBack").click((e) => {
            let mobileNav = $(".js-mobileNav");
            e.preventDefault();

            $('.mobileNav .mainNav').removeClass('hidden');

            // Level02
            if (mobileNav.hasClass("is-level02")) {
                mobileNav.removeClass("is-level02");
                mobileNav.addClass("is-level01");

                mobileNav.find('.js-mobileNavBack').addClass("is-disabled");
                mobileNav.find('.js-activeCategory').text(defaultText);
                mobileNav.find('.level01 a').removeClass("is-active");
            } else if (mobileNav.hasClass("is-level03")) {
                mobileNav.removeClass("is-level03");
                mobileNav.addClass("is-level02");

                mobileNav.find('.js-activeCategory').text(mobileNav.find('.level01 ul li a.is-active:first').text());
                mobileNav.find('.level02 a').removeClass("is-active");
            }
        });
    });

    let changeDOM = (level, elementJQ) => {
        let mobileNav = $(".js-mobileNav");

        mobileNav.find('.js-mobileNavBack').removeClass("is-disabled");

        if (level === 'level01') {
            elementJQ.parent().addClass("is-active");
            mobileNav.removeClass("is-level01");
            mobileNav.addClass("is-level02");
        } else {
            mobileNav.removeClass("is-level02");
            mobileNav.addClass("is-level03");
        }

        elementJQ.addClass("is-active");
        mobileNav.find('.js-activeCategory').text(elementJQ.text());
    }
</script>
